// import { Grid, TextField, MenuItem, Checkbox, Button } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { useAuth } from "../../../Hooks/useAuth";
// import { FileFinepModel, getDocTypeName } from "../../../Models/FileFinepModel";
// import { FaDownload, FaEdit } from "react-icons/fa";
// import { useContext, useEffect, useState } from "react";
// import UploadInputForm from "../UploadInputForm";
// import { DeleteFileFinep, ValidateFileFinep } from "../../../API/FileFinepAPI";
// import Loader from "../../Shared/Loader";
// import { RegistrationDocumentsFinepContext } from "../../../Contexts/RegistrationDocumentsFinepContext";
// import ModalNotificationFinep from "../../ModalNotificationFinep";
// import useCan from "../../../Hooks/useCan";
// import { GetTenantIdSession } from "../../../Utils/StorageSessions";
// import useLoading from "../../../Hooks/useLoading";
// import { GetAllExternalEmailsByTenantAPI } from "../../../API/FinepNotification";
// import { IResponseProps } from "../../../Interfaces/IResponseProps";
// interface UploadInputsProps {
//     fileFinep: FileFinepModel;
//     HandleCheckChange?: (id: string, value: boolean) => void;
//     identification?: string;
// }

// const ExistedInputForm = ({ fileFinep, HandleCheckChange, identification }: UploadInputsProps) => {
//     const [value, setValue] = useState<boolean>(false);
//     const [showDownloadFile, setShowDownloadFile] = useState(true);
//     const [validateFile, setValidateFile] = useState(fileFinep.isValid);
//     const [showEditButton, setShowEditButton] = useState(true);
//     const { handleValidateTab, handleInvalidateTab, handleFillTab, handleUnfillTab, update } = useContext(RegistrationDocumentsFinepContext);
//     const { loading, toggleLoading } = useLoading();
//     const [open, setOpen] = useState<boolean>(false);
//     const [emails, setEmails] = useState<string[]>([]);
//     const canSee = useCan({ rolesCan: ["Manager", "Consultant"] });


//     const tabValue = fileFinep.docType >= 0 && fileFinep.docType <= 3 ? 0 : 1;
//     const tabName = tabValue === 0 ? "Demonstrações FinanceirasSS" : "Documentos Estatutários";

//     const handleClose = () => setOpen(!open);

//     const getEmails = async () => {
//         try {
//             toggleLoading(true);
//             var tenantId = GetTenantIdSession();

//             await GetAllExternalEmailsByTenantAPI(tenantId).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     setEmails(resp.data.resp);
//                     handleClose();
//                 }
//             });
//         } catch (error: any) {

//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const handleEditClick = async () => {
//         await DeleteFileFinep(fileFinep.id);
//         setShowDownloadFile(false);
//     };

//     useEffect(() => {
//         update();
//         if (validateFile === true) {
//             setShowEditButton(false);
//         } else {
//             setShowEditButton(true);
//         }
//     }, [validateFile]);

//     useEffect(() => {
//         const tabValue = fileFinep.docType >= 0 && fileFinep.docType <= 3 ? 0 : 1;

//         handleFillTab(tabValue);

//         if (fileFinep.isValid)
//             handleValidateTab(tabValue);
//     }, []);

//     const { registerId } = useParams();
//     const { userEmail } = useAuth();

//     function toogleShowDownloadFile() {
//         setShowDownloadFile(!showDownloadFile);
//     }

//     async function handleValidateFile(value: boolean) {
//         toggleLoading(true);

//         await ValidateFileFinep(fileFinep.id, value)
//             .catch(x => toggleLoading(false));;

//         setValidateFile(value);

//         if (value === true)
//             handleValidateTab(tabValue);
//         else
//             handleInvalidateTab(tabValue);

//         toggleLoading(false);
//     }
//     function onClick(val: boolean) {
//         setValue(val);
//         HandleCheckChange != undefined && HandleCheckChange(identification ?? "", val);

//     }

//     return (
//         <>
//             {loading && <Loader />}
//             {
//                 showDownloadFile
//                     ? (
//                         <Grid container spacing={2} marginTop={2}>
//                             < Grid item xs={2} />
//                             <Grid item xs={6}>
//                                 <a href={fileFinep.fileAzurePath} className="files-collapse me-4">
//                                     <FaDownload className="font-awesome-icon me-2" />
//                                     <span>{fileFinep.fileName}</span>
//                                 </a>
//                                 {showEditButton &&
//                                     (!fileFinep.isValid || !validateFile)
//                                     && validateFile === false && (
//                                         <Button type="button" variant="contained" className="white" onClick={handleEditClick} >
//                                             <FaEdit className='' />
//                                             <span className='ms-2 white'>Editar</span>
//                                         </Button>
//                                     )
//                                 }

//                             </Grid>
//                             <Grid item xs={2}>
//                                 <TextField
//                                     select
//                                     className="select-width"
//                                     placeholder="Selecione"
//                                     onChange={e => handleValidateFile(e.target.value === "1")}
//                                     defaultValue=""
//                                     value={validateFile === false ? "0" : "1"}
//                                 >
//                                     <MenuItem value="1">Sim</MenuItem>
//                                     <MenuItem value="0">Não</MenuItem>
//                                 </TextField>
//                             </Grid>

//                             <Grid item xs={2} >
//                                 <Checkbox id={identification} value={value} onClick={() => onClick(!value)} style={{ marginLeft: '20px' }} />
//                             </Grid>
//                         </Grid >
//                     ) : (
//                         <UploadInputForm
//                             docType={fileFinep.docType ?? 0}
//                         />
//                     )
//             }
//             <ModalNotificationFinep
//                 open={open}
//                 handleClose={handleClose}
//                 emailsToSelect={emails}
//                 toggleLoading={toggleLoading}
//                 cardName={`Arquivo - ${getDocTypeName(fileFinep.docType)}`}
//                 registerId={registerId ?? ""}
//                 tabName={tabName}
//             />
//         </>
//     );
// }

// export default ExistedInputForm;










import { Row, Col, Checkbox, Button, Spin, Modal, Upload } from "antd";
import { DownloadOutlined, EditOutlined, InboxOutlined, CloseOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";
import { FileFinepModel, getDocTypeName } from "../../../Models/FileFinepModel";
import { useContext, useEffect, useState } from "react";
import { DeleteFileFinep, ValidateFileFinep, PostFileFinep } from "../../../API/FileFinepAPI";
import { RegistrationDocumentsFinepContext } from "../../../Contexts/RegistrationDocumentsFinepContext";
import ModalNotificationFinep from "../../ModalNotificationFinep";
import useCan from "../../../Hooks/useCan";
import { GetTenantIdSession } from "../../../Utils/StorageSessions";
import useLoading from "../../../Hooks/useLoading";
import { GetAllExternalEmailsByTenantAPI } from "../../../API/FinepNotification";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import type { UploadProps } from "antd/es/upload";
interface UploadInputsProps {
    fileFinep: FileFinepModel;
    HandleCheckChange?: (id: string, value: boolean) => void;
    identification?: string;
}
const ExistedInputForm = ({ fileFinep, HandleCheckChange, identification }: UploadInputsProps) => {
    const [value, setValue] = useState<boolean>(false);
    const { Dragger } = Upload;
    const [validateFile, setValidateFile] = useState(fileFinep.isValid);
    const { handleValidateTab, handleInvalidateTab, handleFillTab, handleUnfillTab, update } = useContext(RegistrationDocumentsFinepContext);
    const { loading, toggleLoading } = useLoading();
    const [open, setOpen] = useState<boolean>(false);
    const [emails, setEmails] = useState<string[]>([]);
    const canSee = useCan({ rolesCan: ["Manager", "Consultant"] });
    const [currentFileFinep, setCurrentFileFinep] = useState<FileFinepModel>(fileFinep);
    const tabValue = fileFinep.docType >= 0 && fileFinep.docType <= 3 ? 0 : 1;
    const tabName = tabValue === 0 ? "Demonstrações FinanceirasSS" : "Documentos Estatutários";
    const handleClose = () => setOpen(!open);
    const getEmails = async () => {
        try {
            toggleLoading(true);
            var tenantId = GetTenantIdSession();
            await GetAllExternalEmailsByTenantAPI(tenantId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setEmails(resp.data.resp);
                    handleClose();
                }
            });
        } catch (error: any) {
            console.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const handleRemoveFile = async () => {
        toggleLoading(true);
        try {
            await DeleteFileFinep(currentFileFinep.id);
            setCurrentFileFinep({} as FileFinepModel); 
        } catch (error) {
            console.error("Erro ao remover arquivo:", error);
        } finally {
            toggleLoading(false);
        }
    };
    useEffect(() => {
        update();
        if (validateFile === true) {
            handleValidateTab(tabValue);
        } else {
            handleInvalidateTab(tabValue);
        }
    }, [validateFile]);
    useEffect(() => {
        const tabValue = fileFinep.docType >= 0 && fileFinep.docType <= 3 ? 0 : 1;
        handleFillTab(tabValue);
        if (fileFinep.isValid)
            handleValidateTab(tabValue);
    }, []);
    const { registerId } = useParams();
    const { userEmail } = useAuth();
    async function handleValidateFile(value: boolean) {
        toggleLoading(true);
        await ValidateFileFinep(currentFileFinep.id, value)
            .catch(x => toggleLoading(false));
        setValidateFile(value);
        if (value === true)
            handleValidateTab(tabValue);
        else
            handleInvalidateTab(tabValue);
        toggleLoading(false);
    }
    function onClick(val: boolean) {
        setValue(val);
        HandleCheckChange != undefined && HandleCheckChange(identification ?? "", val);
    }
    
    const handleUpload: UploadProps["customRequest"] = async ({ file }) => {
        toggleLoading(true);
        const formData = new FormData();
        formData.append("files", file as File);
        try {
            if (currentFileFinep.id) await DeleteFileFinep(currentFileFinep.id);
            const response = await PostFileFinep(formData, {
                docType: currentFileFinep.docType,
                pathName: (file as File).name,
                registerId: registerId ?? "",
                userEmail: userEmail,
            });
            setCurrentFileFinep(response.data[0]);
        } catch (error) {
            console.error("Erro no upload:", error);
        } finally {
            toggleLoading(false);
        }
    };
    return (
        <>
            {loading && <Spin />}
            <Row gutter={[16, 16]} style={{ marginTop: 0, width: "100%" }}>
                <Col flex="60%">
                    <Dragger
                        customRequest={handleUpload}
                        showUploadList={false}
                        style={{ width: "100%" }}
                    >
                        {currentFileFinep.id ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <DownloadOutlined className="font-awesome-icon me-2" />
                                    <span>{currentFileFinep.fileName}</span>
                                </div>
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveFile();
                                    }}
                                />
                            </div>
                        ) : (
                            <>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Arraste e solte um arquivo aqui ou clique para selecionar</p>
                            </>
                        )}
                    </Dragger>
                </Col>
                <Col flex="40%" style={{ display: "flex", justifyContent: "center", gap: "120px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Checkbox checked={validateFile} onChange={(e) => handleValidateFile(e.target.checked)} /> Sim
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Checkbox id={identification} value={value} onClick={() => onClick(!value)} /> Sim
                    </label>
                </Col>
            </Row>
            <ModalNotificationFinep
                open={open}
                handleClose={handleClose}
                emailsToSelect={emails}
                toggleLoading={toggleLoading}
                cardName={`Arquivo - ${getDocTypeName(currentFileFinep.docType)}`}
                registerId={registerId ?? ""}
                tabName={tabName}
            />
        </>
    );
}
export default ExistedInputForm;